<template>
    <solid-box
        :priceRate="tradeSum.priceRate[transferVariety]"
        :title="moduleName"
    >
        <div id="echarts-container" class="container" v-auto-size />
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
import { getRelativelySize } from '@/utils/size'

/**
 * 农村集体资产股权
 */
export default {
    echartsInstance: null,
    components: {
        SolidBox
    },
    props: {
        moduleName: {
            type: String,
            default: ''
        },
        transferVariety: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tradeSum: {
                priceRate: {
                    GQ: ''
                }
            }
        }
    },
    destroyed() {
        if (this.echartsInstance) {
            this.echartsInstance.dispose()
        }
    },
    mounted() {
        this.$eventHub.$on('tradeChange', (tradeSum, init) => {
            this.tradeSum = tradeSum
            if (init || !this.echartsInstance) {
                this.init()
            } else {
                this.setEchartOption()
            }
        })
    },
    methods: {
        init() {
            if (this.echartsInstance) return
            const charInstance = echarts.init(
                document.getElementById('echarts-container')
            )
            this.echartsInstance = charInstance
            this.setEchartOption()
        },
        setEchartOption() {
            this.echartsInstance.setOption(this.getOptions())
        },
        delStr(str, num) {
            if (Number(str)) {
                return Number(str).toFixed(num)
            } else {
                return str ? Number(str.replace(/,/g, '')).toFixed(num) : ''
            }
        },
        getOptions() {
            let colors = [
                {
                    start: '#F76B1C',
                    end: '#FAD961'
                },
                {
                    start: '#5746F4',
                    end: '#53A0FD'
                },
                {
                    start: '#6BEF6A',
                    end: '#A4F8A3'
                }
            ]
            let lineColor = '#495F78'
            return {
                grid: {
                    top: getRelativelySize(35),
                    left: getRelativelySize(5),
                    right: getRelativelySize(5),
                    bottom: getRelativelySize(35)
                },
                xAxis: {
                    type: 'category',
                    offset: getRelativelySize(8),
                    data: [
                        {
                            value: this.tradeSum.ctype + '金额(万元)',
                            textStyle: {
                                color: '#fff',
                                fontSize: getRelativelySize(16)
                            }
                        },
                        {
                            value: this.tradeSum.ctype + '笔数(笔)',
                            textStyle: {
                                color: '#fff',
                                fontSize: getRelativelySize(16)
                            }
                        },
                        {
                            value: this.tradeSum.ctype + '数量',
                            textStyle: {
                                color: '#fff',
                                fontSize: getRelativelySize(16)
                            }
                        }
                    ],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: lineColor
                        }
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            },
                            interval: 3
                        }
                    },
                    {
                        type: 'value',
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            },
                            interval: 3
                        }
                    }
                ],
                barWidth: getRelativelySize(49),
                series: [
                    {
                        type: 'bar',
                        data: [
                            {
                                value:
                                    this.delStr(
                                        this.tradeSum.money[
                                            `tradeAmount_${this.transferVariety}`
                                        ],
                                        2
                                    ) || 0.0,
                                itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        1,
                                        0,
                                        0,
                                        [
                                            {
                                                offset: 0,
                                                color: colors[0].start
                                            },
                                            {
                                                offset: 1,
                                                color: colors[0].end
                                            }
                                        ]
                                    )
                                }
                            },
                            {
                                value:
                                    this.delStr(this.tradeSum.count.gq, 0) || 0,
                                itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        1,
                                        0,
                                        0,
                                        [
                                            {
                                                offset: 0,
                                                color: colors[1].start
                                            },
                                            {
                                                offset: 1,
                                                color: colors[1].end
                                            }
                                        ]
                                    )
                                }
                            },
                            {
                                value:
                                    this.delStr(this.tradeSum.area.gq, 2) ||
                                    0.0,
                                itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        1,
                                        0,
                                        0,
                                        [
                                            {
                                                offset: 0,
                                                color: colors[2].start
                                            },
                                            {
                                                offset: 1,
                                                color: colors[2].end
                                            }
                                        ]
                                    )
                                }
                            }
                        ]
                    },
                    {
                        type: 'scatter',
                        symbol: 'triangle',
                        symbolRotate: getRelativelySize(180),
                        symbolSize: [
                            getRelativelySize(12),
                            getRelativelySize(7)
                        ],
                        symbolOffset: [0, getRelativelySize(-11)],
                        itemStyle: {
                            color: '#F9CA49'
                        },
                        label: {
                            show: true,
                            fontSize: 16,
                            color: '#F9CA49',
                            offset: [0, getRelativelySize(-13)]
                        },
                        data: [
                            this.tradeSum.money[
                                `tradeAmount_${this.transferVariety}`
                            ] || 0,
                            this.$toTnteger(this.tradeSum.count.gq) || 0,
                            this.tradeSum.area.gq || 0
                        ]
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 540px;
    height: 215px;
    margin: 17px auto 0;
}
</style>
